module.exports = __webpack_public_path__ + "static/media/480.7d5e7d3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-wheelbarrow/light/480.png
// module id = 2570
// module chunks = 2